import { useApi, configApiRef } from '@backstage/core-plugin-api';
import React, { useEffect, useCallback, useState } from 'react';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import type { FieldValidation } from '@rjsf/utils';

import axios from 'axios';
import { UpdateState, createState } from '../../utils';
import { RepoUrlPickerState } from '../../interfaces';
import { ProjectsResponse } from '@internal/plugin-alm-services';
import ProjectPicker from './ProjectPicker';
import RepositoryType from './RepositoryType';
import RepositoryName from './RepositoryName';

async function getProjects(config: any): Promise<ProjectsResponse> {
  try {
    const baseUrl = config.getString('backend.baseUrl');
    const response = await axios.get(`${baseUrl}/api/azure-devops/projects`);

    return response.data;
  } catch (error: any) {
    console.error(
      'Token request failed:',
      error.response?.data || error.message,
    );
    throw error;
  }
}

const CustomRepoUrlPicker = (props: any) => {
  const { onChange, rawErrors, formData } = props;
  const [projectsResponse, setProjectsResponse] = useState<ProjectsResponse>();
  const [state, setState] = useState<RepoUrlPickerState>(createState(formData));
  const { repositoryType, project, repoName } = state;
  const config = useApi(configApiRef);

  const fetchProjects = async () => {
    const res = await getProjects(config);
    setProjectsResponse(res);
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    onChange(UpdateState(state, projectsResponse?.value || []));
  }, [state, onChange]);

  const updateLocalState = useCallback(
    (newState: RepoUrlPickerState) => {
      setState(prevState => ({ ...prevState, ...newState }));
    },
    [setState],
  );

  return (
    <>
      <ProjectPicker
        project={project}
        projects={projectsResponse?.value.map(x => x.name)}
        onChange={updateLocalState}
        rawErrors={rawErrors}
      />
      <RepositoryType
        repositoryType={repositoryType}
        onChange={updateLocalState}
        rawErrors={rawErrors}
      />
      <RepositoryName
        repoName={repoName}
        onChange={updateLocalState}
        rawErrors={rawErrors}
      />
    </>
  );
};

const validateRepoUrlPickerValidation = (
  value: RepoUrlPickerState,
  validation: FieldValidation,
) => {
  if (!value.project && value.project === '')
    validation.addError(`- Azure Devops Project can not be empty`);

  if (!value.repositoryType && value.repositoryType === '')
    validation.addError(`- Repository Type can not be empty`);

  if (!value.repoName && value.repoName === '')
    validation.addError(`- Repository Name can not be empty`);
};

export const RepoUrlPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'CustomRepoUrlPicker',
    component: CustomRepoUrlPicker,
    validation: validateRepoUrlPickerValidation,
  }),
);
